@let cartData = cart();
@let bounds = cartData?.bounds;

@if (cartData && bounds?.length) {
  <div
    data-testid="shopping-cart-component"
    class="cart fill nordic-blue-900-text white-bg text-icon-primary flex flex--column"
    [ngClass]="{
      'rounded-large overflow-hidden border': !isInsideModal(),
      'ps-small-b': !isInsideModal(),
      grow: isInsideModal(),
    }"
  >
    <div
      [ngClass]="{
        'sticky top z1': isInsideModal(),
      }"
    >
      <section
        class="ps-small"
        [ngClass]="{
          'nordic-blue-25-bg surface-secondary': !isInsideModal(),
          'nordic-blue-900-bg surface-contrast white-text text-icon-reversed rounded-top-large no-rounding-on-phone':
            isInsideModal(),
        }"
      >
        <h2 class="font-heading-4 flex flex--space-between flex--middle font-title-medium">
          <span>{{ 'shoppingCart.title' | finLocalization }}</span>
          @if (!isInsideModal()) {
            <span data-testid="shopping-cart-total">{{ cartTotal() | finPrice }}</span>
          }
        </h2>
      </section>
      @if (isInsideModal()) {
        <section class="nordic-blue-25-bg surface-secondary ps-small" data-testid="cart-total-price">
          <div class="flex flex--space-between flex--middle">
            <span class="font-body-1 font-body-medium">
              {{ 'shoppingCart.totalPriceInfo' | finPluralLocalization: cartData.passengers?.length ?? 1 }}
            </span>
            <span class="font-heading-4 font-title-medium">{{ cartTotal() | finPrice }}</span>
          </div>
        </section>
      }
      <div [ngClass]="{ 'elevation-level-1 nordic-blue-25-bg surface-secondary': isInsideModal() }">
        <fin-shopping-cart-passengers
          [passengers]="cartData.passengers"
          [selectedPassengerId]="selectedPassengerId()"
          (passengerSelected)="selectPassenger($event)"
          (tabsVisible)="showPassengerTabs.set($event)"
        ></fin-shopping-cart-passengers>
      </div>
    </div>
    <div
      class="flex-1 scroll"
      data-testid="shopping-cart-content"
      [attr.role]="showPassengerTabs() ? 'tabpanel' : null"
      [attr.id]="showPassengerTabs() ? 'sc-pax-panel' : null"
      [attr.tabindex]="showPassengerTabs() ? 0 : null"
    >
      @for (bound of bounds; track bound.id; let i = $index) {
        <fin-shopping-cart-bound
          [bound]="bound"
          [selectedPassengerId]="selectedPassengerId()"
          [price]="offerBoundsPrices()[i]"
          [passengerCount]="passengerCount()"
          (openFareFamilyDetails)="openFareFamilyDetails(cartData.benefits[bound.fareFamily.code])"
          (openItineraryDetails)="openItineraryDetails(bound, bounds, i, cartData.locations)"
        />
      }
      <div
        class="flex flex--space-between flex--middle ms-small nordic-blue-50-bg surface-secondary rounded-medium ps-small font-body-1 font-body-medium"
      >
        <span>
          {{
            'shoppingCart.totalPriceInfo'
              | finPluralLocalization: (selectedPassengerId() ? 1 : (cartData.passengers?.length ?? 1))
          }}
        </span>
        <span data-testid="shopping-cart-total-per-passenger" class="font-heading-4 font-title-medium nowrap">{{
          cartTotalPricePerPassenger() | finPrice
        }}</span>
      </div>
    </div>
    @if (isInsideModal()) {
      <div
        class="nordic-blue-900-bg surface-contrast flex--nogrow ps-small flex g-small"
        [class.flex--center]="!showCtaButton()"
      >
        <fcom-button
          data-testid="close-shopping-cart-cta"
          [class.flex-1]="showCtaButton()"
          (clickBtn)="closeShoppingCart()"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [mode]="ButtonMode.FILL"
          [text]="'shoppingCart.closeCart' | finLocalization"
          [aria]="{ label: 'shoppingCart.closeCart' | finLocalization, role: 'button' }"
        />
        @if (showCtaButton()) {
          <fcom-button
            class="flex-1"
            data-testid="shopping-cart-modal-cta-button"
            (clickBtn)="handleModalCtaButtonClick()"
            [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
            [mode]="ButtonMode.FILL"
            [text]="modalCtaButtonText()"
            [aria]="{ label: modalCtaButtonText(), role: 'button' }"
          />
        }
      </div>
    }
  </div>
}

<fcom-modal
  [title]="'shoppingCart.fareFamilyModalTitle' | finLocalization"
  [isNestedModal]="isInsideModal()"
  [buttons]="ModalButtons.DONE"
  [(open)]="fareFamilyModalData.isOpen"
>
  <fin-fare-family-details class="block pr-medium" [fareFamilies]="[fareFamilyModalData.fareFamily]" />
</fcom-modal>

<fcom-modal
  [title]="'shoppingCart.itineraryModalTitle' | finLocalization"
  [isNestedModal]="isInsideModal()"
  [buttons]="ModalButtons.DONE"
  [(open)]="itineraryModalData.isOpen"
>
  <fin-itinerary-timeline
    class="block pr-medium"
    [locations]="itineraryModalData.locations"
    [bound]="itineraryModalData.bound"
    [boundType]="itineraryModalData.boundType"
    [isBookingFlow]="true"
  />
</fcom-modal>
